// components/CancellationRefund.js


import React from 'react';
import styles from './Cancle.module.css';

const CancellationRefund = () => {
  return (
    <section className={styles['refund-section']}>
      <div className={styles['container']}>
        <h2 className={styles['heading']}>Cancellation & Refund Policy</h2>
        <p className={styles['paragraph']}>
          At MetalZulu, we strive to provide the best experience possible. Please review our cancellation and refund policy carefully.
        </p>

        <h3 className={styles['subheading']}>1. Subscription Cancellation</h3>
        <p className={styles['paragraph']}>
          You may cancel your subscription at any time by accessing your account settings. Upon cancellation, your plan will remain active until the end of the current billing cycle.
        </p>

        <h3 className={styles['subheading']}>2. Refund Eligibility</h3>
        <p className={styles['paragraph']}>
          We offer refunds only within 7 days of your initial purchase, provided you have not extensively used the service. After this period, no refunds will be issued.
        </p>

        <h3 className={styles['subheading']}>3. Partial Refunds</h3>
        <p className={styles['paragraph']}>
          Partial refunds may be granted in exceptional cases at our sole discretion (e.g., technical issues not resolved within a reasonable time).
        </p>

        <h3 className={styles['subheading']}>4. Refund Process</h3>
        <p className={styles['paragraph']}>
          Approved refunds will be processed within 7–10 business days to your original payment method. A confirmation will be sent to your registered email.
        </p>

        <h3 className={styles['subheading']}>5. Contact Us</h3>
        <p className={styles['paragraph']}>
          For any questions or refund requests, please email us at support@metalzulu.com. We’re here to help!
        </p>
      </div>
    </section>
  );
};

export default CancellationRefund;
